import { render, staticRenderFns } from "./LocationAdministrationEditor.vue?vue&type=template&id=05085069&scoped=true&"
import script from "./LocationAdministrationEditor.vue?vue&type=script&lang=js&"
export * from "./LocationAdministrationEditor.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdministrationEditor.vue?vue&type=style&index=0&id=05085069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05085069",
  null
  
)

/* custom blocks */
import block0 from "./LocationAdministrationEditor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05085069')) {
      api.createRecord('05085069', component.options)
    } else {
      api.reload('05085069', component.options)
    }
    module.hot.accept("./LocationAdministrationEditor.vue?vue&type=template&id=05085069&scoped=true&", function () {
      api.rerender('05085069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/location-administration/LocationAdministrationEditor.vue"
export default component.exports